var map = {
	"./base": 119,
	"./base.vue": 119,
	"./birthday": 296,
	"./birthday.vue": 296,
	"./donate": 297,
	"./donate.vue": 297,
	"./phapa": 298,
	"./phapa.vue": 298,
	"./special-events": 299,
	"./special-events.vue": 299
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 819;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/products ^\.\/.*$
// module id = 819
// module chunks = 1